import { type ResourceContainer } from "../../gql-generated/types";

export const getDefaultOrganizationContainerV2 = (
    organizations: ResourceContainer[],
    defaultOrganizationId: string,
): ResourceContainer | undefined => {
    const defaultOrganization = organizations.find(({ id }) => id === defaultOrganizationId) ?? organizations[0];
    return defaultOrganization;
};

export const makeAllContainersMapV2 = (organizations: ResourceContainer[]): Map<string, ResourceContainer> => {
    const containersMap = new Map<string, ResourceContainer>();

    for (const container of organizations) {
        containersMap.set(container.id, container);
    }

    return containersMap;
};
